import { render } from "./TenantTemplateEditor.vue?vue&type=template&id=7babc970&scoped=true"
import script from "./TenantTemplateEditor.vue?vue&type=script&lang=js"
export * from "./TenantTemplateEditor.vue?vue&type=script&lang=js"

import "./TenantTemplateEditor.vue?vue&type=style&index=0&id=7babc970&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7babc970"]])

export default __exports__